"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconHuawei = exports.IconApple = exports.IconAndroid = exports.ItemLinkText = exports.ItemLink = exports.DefaultContainer = void 0;
const Android_1 = __importDefault(require("@kawaui/icons/build/icons/social/Android"));
const Apple_1 = __importDefault(require("@kawaui/icons/build/icons/social/Apple"));
const Huawei_1 = __importDefault(require("@kawaui/icons/build/icons/social/Huawei"));
const link_1 = __importDefault(require("@kawaui/link"));
const styled_components_1 = __importStar(require("styled-components"));
exports.DefaultContainer = styled_components_1.default.div ``;
exports.ItemLink = (0, styled_components_1.default)(link_1.default) `
  display: inline-flex;
  align-items: center;

  color: ${({ theme }) => theme.colors.gray.s700};
  text-decoration: ${({ premium }) => (premium ? 'underline' : 'none')};

  svg {
    width: 24px;
    height: 24px;
    margin-right: ${({ theme }) => theme.space.s050};
  }

  &:hover {
    path {
      fill: ${({ theme }) => theme.colors.main.base};
    }
  }
`;
exports.ItemLinkText = styled_components_1.default.span `
  @media screen and (max-width: ${({ theme }) => theme.breakpoint.desktop}) {
    display: ${({ hideTitleMobile }) => (hideTitleMobile ? 'none' : 'block')};
  }
`;
const lightColor = (0, styled_components_1.css) `
  path {
    fill: ${({ theme }) => theme.colors.gray.s500};
  }
`;
exports.IconAndroid = (0, styled_components_1.default)(Android_1.default) `
  ${lightColor}
`;
exports.IconApple = (0, styled_components_1.default)(Apple_1.default) `
  ${lightColor}
`;
exports.IconHuawei = (0, styled_components_1.default)(Huawei_1.default) `
  ${lightColor}
`;
